module.exports = __webpack_public_path__ + "img/window-M.3465fd80.svg";